import { Typography } from "@mui/material";
import { connect } from "react-redux";
import Checkbox from "@mui/material/Checkbox";
import { useState } from "react";
import { Button } from "@mui/material";
import { Box } from "@mui/system";
import { submitOrderSubs } from "../actions/user";
import { Link } from "react-router-dom";
import { getItem } from "../utils/DataProtection";
export default connect(
  ({
    // to use redux states here
    i18n,
    isLoading,
    orderSubscription,
  }) => ({
    i18n,
    isLoading,
    orderSubscription,
  }),
  {
    submitOrderSubs,
    // redux functions
  }
)((props) => {
  let i18n = props.i18n;
  const isLoading = props.isLoading;
  const [checked, setChecked] = useState(false);
  const handleStep = (value) => {
    const clientid = JSON.parse(getItem("clientid"));
    const sumPerMonth = getItem("total");
    const data = {
      ...props.orderSubscription,
      billEmail: props.orderSubscription.invoiceEmail,
      country: props.orderSubscription.country.label,
      clientid: clientid,
      userEmail: props.orderSubscription.email,
      sumPerMonth:sumPerMonth
    };


    props.submitOrderSubs({ data: data });

    // handleStep2 logic here
    props.handleStep(value);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  return (
    <div className="card-info">
      <Typography variant="h1">{i18n.purchaseComplete_title}</Typography>
      <Box sx={{ display: "flex", alignItems: "center", marginBottom: 2 }}>
        <Checkbox
          onChange={handleChange}
          inputProps={{ "aria-label": "controlled" }}
          value={checked}
          sx={{ marginRight: 1 }}
        />
        <p>
          Hiermit stimme ich den
          <Link
            to="https://247factorynet.com/de/agbs"
            target="_blank"
            rel="noopener noreferrer"
            className="light-text"
          >
            Allgemeinen Geschäftsbedingungen
          </Link>
          und den
          <Link
            to="https://247factorynet.com/de/datenschutzerklaerung"
            rel="noopener noreferrer"
            target="_blank"
            className="light-text"
          >
            Informationen zur Datenverarbeitung
          </Link>
          durch die 247FactoryNet GmbH zu.
        </p>
      </Box>
      <Button variant="contained" onClick={handleStep} disabled={!checked}>
        Abo kostenpflichtig abschließsen
      </Button>
    </div>
  );
});
